<template lang="pug">
  .notification.row.middle.center(v-if='showNotification')
    .container.row.middle.center
      .content.text-normal.md-content.md-small.md-white(v-html='currentNotification.headline')
      button.m-left-1(@click='hide')
        simple-svg.white-icon(:filepath='crossIcon' width='18px' height='18px')
</template>

<script>
import crossIcon from '@/assets/ic_cross.svg'
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      crossIcon,
      activeIndex: 0,
      loading: false
    }
  },
  watch: {
    async locale() {
      this.loading = true
      await this.hydrateHighlightNotification()
      this.loading = false
    }
  },
  computed: {
    ...mapState({
      highlight: state => state.notifications.highlight,
      locale: state => state.behavior.locale,
      notifications: state => state.notifications.highlight.notifications
    }),
    currentNotification() {
      return this.notifications[this.activeIndex]
    },
    showNotification() {
      return (this.notifications && this.notifications.length && !this.highlight.seen) && !this.loading
    }
  },
  methods: {
    ...mapActions([
      'markHighlightNotificationSeen',
      'hydrateHighlightNotification'
    ]),
    hide() {
      if (this.notifications.length > 1 && this.activeIndex < (this.notifications.length - 1)) {
        this.activeIndex = this.activeIndex + 1
      } else {
        this.markHighlightNotificationSeen()
        this.$destroy()
        this.$el.parentNode.removeChild(this.$el)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';
@import 'src/scss/variables/sizes';
@import 'src/scss/common/texts';

.notification{
  width: 100%;
  min-height: 45px;
  padding: 10px 0;
  background-color: $black;
  .container{
    max-width: $content-size;
  }
}
/deep/ .content{
  text-align: center;
  a{
    text-decoration: underline;
  }
}
</style>
